<template>
    <div class="main">
        <!-- channel banner -->
        <div class="cbanner">
            <img src="../../../assets/images/banner_intro.jpg" />
            <div class="btext">
                <h3>服务模式</h3>
                <p>以客户为本，真诚服务，持续创新，追求卓越</p>
            </div>
        </div><!-- channel banner END-->
        <div class="main_inner">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <span class="btitle">当前位置：</span>
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>平台概况</el-breadcrumb-item>
                <el-breadcrumb-item>服务模式</el-breadcrumb-item>
            </el-breadcrumb>
            <el-row>

                <el-col :span="5" class="leftside">
                    <el-menu
                            default-active="2"
                            class="el-menu-vertical-demo"
                           >
                        <router-link :to="{ path: '/centerIntroduce' }">
                            <el-menu-item index="1"><span slot="title" >平台简介</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/serviceScope' }">
                            <el-menu-item index="2"><span slot="title">服务模式</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/managementAim' }">
                            <el-menu-item index="3"><span slot="title">经营宗旨</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/platformAdvantage' }">
                            <el-menu-item index="4"><span slot="title">平台优势</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/organizationalStructure' }">
                            <el-menu-item index="5"><span slot="title">组织架构</span></el-menu-item>
                        </router-link>
                    </el-menu>
                </el-col>

                <el-col :span="19">
                    <div class="con_right">
                        <div class="con">
                            <div v-html="this.content">


                            </div>
                            <!--<h4 class="title_intro">西咸新区普惠民间借贷服务中心(服务范围)</h4>-->
                                    <!--<div>-->
                                    <!--<p>陕西普惠投融信息服务有限公司筹划建设普惠民间借贷服务中心（简称：借贷服务中心）网站平台，拟提供线上借贷信息登记，借贷信息咨询，投融资中介服务，企业管理信息咨询等业务。</p>-->
                                    <!--<p>该借贷服务中心平台建成后，线上可通过电脑端、手机端完成借贷信息展示，借贷信息登记，业务流程记录，投融资资讯展示，法律法规展示，企业形象宣传；线下可通过专业客服对接，精准营销，建立业务流程标准化管理，实现线上到线下，线下到线上闭环的借贷及投融资服务综合平台。</p>-->
                                    <!--<p class="bold">服务宗旨：</p>-->
                                    <!--<p>-->
                                        <!--1、遏制非法融资，防范和化解民间金融风险，促使民间借贷行为阳光化、规范化。-->
                                        <!--2、实行借贷双方直接对接；为民间借贷行为提供规范操作模式。-->
                                        <!--3、借贷双方资金直接结算，中心不接触资金、不代理结算。-->
                                        <!--4、中心杜绝高利贷行为。</p>-->
                                    <!--</div>-->
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import {reqServiceScopeList} from '../../../api/contentManagement-api'
    export default {
        data(){
            return{
                content:'',
            }
        },
        methods:{
            getServiceScope(){
                reqServiceScopeList().then((res)=>{
                    if(res.data.code===1){
                        this.content=res.data.data[0].content
                    }else{
                        this.content="<p>抱歉，暂无数据</p>"
                    }
                })
            }
        },
        mounted(){
          this.getServiceScope();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/contentManagement/centerSituation/serviceScope.vue